import {
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
  RaRecord,
} from "react-admin";
import { getJson } from "../../../utils/api";
import IHandler from "./IHandler";

export default class ThreadsHandler implements IHandler {
  static route = "/admin/profiles";
  static resourceIdName = "user_id";

  static async getListHandler<RecordType extends RaRecord = any>(
    resource?: string,
    params?: GetListParams
  ): Promise<GetListResult<RecordType>> {
    const page = params?.pagination.page ?? 1;

    const query: { [key: string]: any } = {
      // fetch_details: false,
      limit: params?.pagination.perPage ?? 100,
      page,
      ...params?.filter,
    };

    return getJson(`${resource}?${new URLSearchParams(query).toString()}`).then(
      async (response) => {
        let { threads: responseData } = await response.json();

        responseData = responseData?.length > 0 ? responseData.reverse() : [];

        let idx = 1;

        responseData = responseData.map((data: any) => {
          const result = {
            idx,
            ...data,
          };
          idx++;
          result.id = data.thread_id;

          return {
            ...result,
          };
        });

        return {
          data: responseData.reverse(),
          pageInfo: {
            hasNextPage: true,
            hasPrevPage: page > 1,
          },
        };
      }
    );
  }

  static async getOneHandler<RecordType extends RaRecord = any>(
    resource: string,
    params?: GetOneParams<any>
  ): Promise<GetOneResult<RecordType>> {
    const id = params?.id;
    return getJson(`${this.route}/${id}`).then(async (response) => {
      const { data } = await response.json();

      data.id = data[this.resourceIdName];
      delete data[this.resourceIdName];

      return {
        data: {
          ...data,
        },
      };
    });
  }
}
